<template>
  <div>
    <div class="ttshop_coupon">
      <div class="flexsb">
        <div class="fap_title">
          发票信息
        </div>
        <div>
          <ul>
            <li class="m24">
              <span class="gwidth">发票类型：</span><span class="f12">{{Invoiceinfomation.type=="1"?"个人" :"企业"}}</span>
            </li>
            <li class="m24">
              <span class="gwidth">发票类型：</span><span class="f12">{{Invoiceinfomation.invoice_type=="1"?"增值税普通发票" :"增值税专用发票"}}</span>
            </li>
            <li class="m24">
              <span class="gwidth">发票抬头：</span><span class="f12">{{Invoiceinfomation.header}}</span>
            </li>
            <li class="m24"
                v-if="Invoiceinfomation.type==2">
              <span class="gwidth">纳税人识别码：</span><span class="f12">{{Invoiceinfomation.taxpayer}}</span>
            </li>

            <div v-if="Invoiceinfomation.invoice_type==2">

              <li class="m24">
                <span class="gwidth">开户行：</span><span class="f12">{{Invoiceinfomation.bank_name}}</span>
              </li>
              <li class="m24">
                <span class="gwidth">注册地址：</span><span class="f12">{{Invoiceinfomation.register_address}}</span>
              </li>
              <li class="m24">
                <span class="gwidth">注册电话：</span><span class="f12">{{Invoiceinfomation.register_tel}}</span>
              </li>
            </div>

          </ul>
          <div class="flex">
            <div class="del"
                 style="margin-right: 8px;"
                 @click="delInvoice()">删除</div>
            <div class="edit"
                 @click="editInvoice(Invoiceinfomation)">编辑</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  props: ['Invoiceinfomation'],
  data() {
    return {
      id: '' //删除id
    }
  },
  created() {},
  mounted() {},
  methods: {
    delInvoice() {
      let data = {
        shop_type: 'qycg',
        id: this.Invoiceinfomation.id
      }
      this.$confirm('确定是否要删除次发票?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.DelInvoice(data).then(res => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.$parent.fanhui()
              this.$parent.invoiceList()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    editInvoice(i) {
      this.$parent.detailsEditing(i)
    }
  }
}
</script>
<style lang="scss" scoped>
.ttshop_coupon {
  width: 100%;
  background: #fff;
  padding: 24px 20px;
  box-sizing: border-box;

  .flexsb {
    background: #fff;
    z-index: 999999;
    margin-top: 10px;
  }
  .fap_title {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333;
  }
  .m24 {
    margin-top: 24px;
  }
  .gwidth {
    width: 84px;
    text-align: right;
    display: inline-block;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999;
  }
  .flex {
    display: flex;
    margin-top: 32px;
    margin-left: 127px;
  }
  .del,
  .edit {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    text-align: center;
    line-height: 30px;
  }
  .del {
    width: 78px;
    height: 28px;
    border-radius: 2px;
    border: 1px solid #ff0e25;
    color: #ff0e25;
  }
  .edit {
    width: 80px;
    height: 30px;
    background: #ff0e25;
    border-radius: 2px;
    color: #fff;
  }
  .f12 {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333;
    margin-left: 16px;
  }
}
</style>